import { render, staticRenderFns } from "./SendProposalModal.vue?vue&type=template&id=63980081&"
import script from "./SendProposalModal.vue?vue&type=script&lang=js&"
export * from "./SendProposalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports